import {
  Component,
  ElementRef,
  Input,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'sd-tab',
  templateUrl: '../tab/tab.component.html',
  standalone: true
})
export class SdTabComponent {
  constructor(public elRef: ElementRef) {}

  @Input()
  disabled = false;

  @Input()
  isDropdown = false;

  @Input()
  isHiddenTab = false;

  @ViewChild('titleElement')
  titleElementRef: ElementRef;

  @ViewChild('bodyElement')
  bodyElementRef: ElementRef;
}
